import React from "react";
import SlotCapacityUpdate from "../../components/Slots/BulkUploadSlots";

const Slots = (props) => {
  return <SlotCapacityUpdate />;
};

export default Slots;
